import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "components/Button";
import { Input } from "components/Input";
import { PageWithNav } from "components/PageWithNav";
import { TextEditor } from "components/TextEditor";
import api from "utils/api";
import { useToastContext } from "context/ToastContext";

export const CreateCourse = () => {
  const navigate = useNavigate();
  const { notify } = useToastContext();
  const [heroImage, setHeroImage] = useState("");
  const [description, setDescription] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    formData.set("description", description);
    formData.set("hero_image", heroImage);

    try {
      setIsLoading(true);
      await api.post("/course", formData);
      setIsLoading(false);
      notify({ title: "Success", description: "Course added!", type: "success" });
      navigate("/courses");
    } catch (e) {
      setIsLoading(false);
      console.error(e);
    }
  };

  return (
    <PageWithNav>
      <h1 className="mb-5 pe-4 text-xl font-semibold text-neutral-900">Create new course</h1>
      <form onSubmit={handleSubmit} data-testid="create-course">
        <Input id="name" name="name" type="text" required label="Course name" placeholder="f.e Detailing" />
        <Input id="time_to_complete" name="time_to_complete" type="text" required label="Time to complete" placeholder="15 hours" />
        <Input id="hero_image" value={heroImage} onChange={(e) => setHeroImage(e.target.value)} name="hero_image" type="text" required label="Hero Image" placeholder="https://gcs.image.png" />
        {heroImage && (
          <div className="max-w-100 mx-auto my-4 items-center rounded-lg bg-gray-100 p-6 text-center">
            <img src={heroImage} alt="Preview" className="mx-auto max-h-48 rounded-lg" />
          </div>
        )}
        <TextEditor value={description} onChange={setDescription} id="description" label="Course description (more detailed course info)" />
        <div className="my-4 flex gap-2">
          <Button disabled={isLoading} onClick={() => navigate("/courses")} color="secondary" size="sm">
            Cancel
          </Button>
          <Button disabled={isLoading} loading={isLoading} type="submit" color="primary" size="sm">
            Save
          </Button>
        </div>
      </form>
    </PageWithNav>
  );
};
